module.exports = __webpack_public_path__ + "static/media/info-graphic.28f5736e.jpg";